import CirgsReportCustomersList from './CirgsReportCustomersList';

export default CirgsReportCustomersList;
